import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_INDICATOR_DATA_REQUEST } from '../actions/actionTypes';
import { fetchIndicatorDataSuccess, fetchIndicatorDataError } from '../actions/IndicatorAction';
import { getProviderMetricsIds } from '@src/utility/common.service';
 

export function* fetchIndicatorData(action: any) {
  try {
    const response = yield call(getProviderMetricsIds);
    if (response) {
      yield put(fetchIndicatorDataSuccess(response));
    }

  } catch (error) {
    yield put(fetchIndicatorDataError(error));
  }

}
export function* indicatorSaga() {
  yield takeLatest(FETCH_INDICATOR_DATA_REQUEST, fetchIndicatorData);
}

export default [indicatorSaga]